import { ContactUs, CopyrightFooter, DataGrid } from 'app/components';
import { Container, IAppState } from 'app/containers/Container';
import * as React from 'react';
import { Col, Glyphicon, Panel, Row, Tab, Table, Tabs } from 'react-bootstrap';
import { FoundationMark50Sources, IFiftyRow } from './DataSources';
import { TopFoundations } from 'app/components/visualizations/TopFoundations';

interface IFoundationMark50State {
  data: IFiftyRow[];
}

class FoundationMark50 extends Container<{}, IFoundationMark50State> {
  mapAppStateToContainerState(appState: IAppState) {
    return { data: [] };
  }

  componentWillMount() {
    super.componentWillMount();
    this.renderStars = this.renderStars.bind(this);
  }

  componentDidMount() {
    this.loadFoundationMark50();
  }

  loadFoundationMark50() {
    const assetLevelRequest = {
      method: 'POST',
      body: JSON.stringify({ action: 'foundationmark50', state: '', assetLevel: 0, monthNumber: 12 }),
    };
    fetch('https://kbqk6mximj.execute-api.us-east-1.amazonaws.com/Test/foundationmark50', assetLevelRequest)
      .then((resp) => resp.json())
      .then((json) => {
        // tslint:disable-next-line:no-console
        this.setState({ data: json });
      });
  }

  redirect(url) {
    location.hash = url;
  }

  renderStars(numberOfStars: number) {
    const html = [];
    for (let i = 0; i < numberOfStars; i++) {
      html.push(<i className="fa fa-star" aria-hidden="true" />);
    }
    return html;
  }

  renderCurrency(totalAssets: number) {
    return <span>{totalAssets.toLocaleString()}</span>;
  }

  static renderLoadingScreen(noData) {
    let loadingHtml = null;
    if (noData) {
      loadingHtml = <i className="fa fa-cog fa-spin"></i>;
    }
    return loadingHtml;
  }

  render() {
    const { data } = this.state;
    const renderStars = this.renderStars.bind(this);
    const renderCurrency = this.renderCurrency.bind(this);
    let rowCount = 0;
    //const loadFoundationDetails = this.loadFoundationDetails(row).bind(this)
    const eventKeyIndex = 1;
    return (
      <section className="container margin-bottom" style={{ overflowX: 'hidden' }}>
        <section className="animated fadeIn">
          <header className="margin-bottom">
            <Row>
              <Col xs={12} style={{ paddingTop: '25px' }}>
                <Panel>
                  <div className="panel-heading">
                    <h6 className="panel-title" style={{ fontSize: '1.5em', textAlign: 'center' }}>
                      FoundationMark 15
                    </h6>
                  </div>
                  <div className="panel-body">
                    <p style={{ fontSize: '15px', lineHeight: '1.5' }}>
                      The FoundationMark 15, (“FM 15”) is a selection of 15 of the largest and best-known private foundations in the United
                      States. Like all foundations, the FM 15 rely on their investment returns as an important, often the only, source of
                      income to support their philanthropic goals. Better performance means more money available to support important
                      causes. The FoundationMark Star Ratings are based on <a href="#/faq?id=performanceMatters">performance estimates</a>{' '}
                      calculated by FoundationMark using publicly available data. The performance estimates for over 40,000 foundations are
                      sorted and grouped by quintile, forming the basis for the star rankings.{' '}
                    </p>
                    <p>
                      If you are a trustee of a private foundation and would like your free report including your star ranking please{' '}
                      <a href="#/are-you-foundation">click here.</a>
                    </p>
                  </div>
                </Panel>
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <Panel>
                  <div className="panel-heading">
                    <h5 className="card-title" style={{ textAlign: 'center' }}>
                      <span style={{ float: 'left', fontSize: '14px', fontWeight: 700 }}>$ in millions</span>FoundationMark Star
                      Rankings&nbsp;{FoundationMark50.renderLoadingScreen(data.length === 0)}
                    </h5>
                  </div>
                  <div className="panel-body">
                    <TopFoundations />
                  </div>
                </Panel>
              </Col>
            </Row>
            <Row>
              <Col xs={12} style={{ paddingTop: '25px' }}>
                <Panel>
                  <div className="panel-heading">
                    <h6 className="panel-title" style={{ fontSize: '1.5em', textAlign: 'center' }}>
                      Composition of the FoundationMark 15
                    </h6>
                  </div>
                  <div className="panel-body">
                    <p style={{ fontSize: '15px', lineHeight: '1.5' }}>
                      The selection criteria for membership in the FoundationMark 15 includes qualifying factors such as the percentage of
                      investable assets versus non-investable assets, number of years in operation, levels of incoming and outgoing cash
                      flow as a percent of assets, and other characteristics. The FoundationMark 15 is not designed to be a representative
                      sample of all foundations. FoundationMark has observed that larger foundations outperform smaller foundation. The
                      FoundationMark 15 is comprised exclusively of large foundations resulting in a high concentration of 4-Star and 5-Star
                      foundations.
                    </p>
                  </div>
                </Panel>
              </Col>
            </Row>
          </header>
        </section>
        <ContactUs />
        <CopyrightFooter />
      </section>
    );
  }
}

export { FoundationMark50 };



// WEBPACK FOOTER //
// ./src/app/containers/FoundationMark50/index.tsx